const AppLayoutPlugin = {
  install (Vue) {
    const smallSize = 600
    Vue.prototype.isThinScreenWidthVuetify = ($vuetify) => $vuetify.breakpoint.width < smallSize
    Vue.prototype.isShortScreenHeightVuetify = ($vuetify) => $vuetify.breakpoint.height < smallSize
    Vue.prototype.isSmallScreenVuetify = ($vuetify) => {
      const vb = $vuetify.breakpoint
      return (vb.height < smallSize && vb.width < 2 * smallSize) || vb.width < smallSize
    }
    Vue.prototype.isAppBarVisible = ($vuetify) => $vuetify.breakpoint.width > 800 || $vuetify.breakpoint.height > 800
  }
}

export default AppLayoutPlugin
